import {
  List,
  Datagrid,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  Show,
  SimpleShowLayout,
  BooleanField,
  BooleanInput,
  UrlField,
} from 'react-admin';

export const FundList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="uid" label="UID" />
      <UrlField source="website" />
      <BooleanField source="is_individual" />
    </Datagrid>
  </List>
);

export const FundEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="name" />
      <TextInput source="uid" label="UID" />
      <TextInput source="website" type="url" />
      <BooleanInput source="is_individual" />
    </SimpleForm>
  </Edit>
);

export const FundCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" required />
      <TextInput source="uid" label="UID" required />
      <TextInput source="website" type="url" />
      <BooleanInput source="is_individual" defaultValue={false} />
    </SimpleForm>
  </Create>
);

export const FundShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="uid" label="UID" />
      <UrlField source="website" />
      <BooleanField source="is_individual" />
    </SimpleShowLayout>
  </Show>
);
